import { Radio } from '@mui/material';
import { List, Datagrid, TextField, FunctionField, TopToolbar, FilterButton, TextInput } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { AccountStatusChip, PhoneNumberArrayField } from 'src/lib';
import { BaseAccount } from 'src/models';

const LinkAdditionalAccountListFilters = [
  <TextInput key='accountId' label='Account Id' source='accountId' />,
  <TextInput key='accountNumber' label='Account number' source='accountNumber' alwaysOn />,
  <TextInput key='firstName' label='First name' source='firstName' />,
  <TextInput key='lastName' label='Last name' source='lastName' />,
  <TextInput key='email' label='Email' source='email' />,
  <TextInput key='phoneNumber' label='Phone number' source='phoneNumber' />,
];

const LinkAdditionalAccountListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
    </TopToolbar>
  );
};

interface LinkAdditionalAccountListProps {
  value?: BaseAccount;
  rootAccountId: string;
  accounts?: BaseAccount[];
  onChange?: (account?: BaseAccount) => void;
}

export const LinkAdditionalAccountList = ({
  value,
  rootAccountId,
  accounts,
  onChange,
}: LinkAdditionalAccountListProps) => {
  return (
    <List
      title='Accounts'
      resource={DataProviderResource.Accounts}
      filters={LinkAdditionalAccountListFilters}
      filter={{
        skipBalance: true,
        exclude: accounts?.map(acc => acc.id),
        status: 'Submitted',
      }}
      sort={{ field: 'createdAt', order: 'DESC' }}
      actions={<LinkAdditionalAccountListActions />}>
      <Datagrid bulkActionButtons={false}>
        <FunctionField
          render={(record: BaseAccount) => {
            return (
              <Radio
                checked={record.id === value?.id}
                onChange={() => onChange?.(record)}
                disabled={
                  !Boolean(record.accountId) ||
                  (record.type.isEntity && !record.accountNumber) ||
                  record.id === rootAccountId ||
                  accounts?.some(acc => acc.id === record?.id)
                }
              />
            );
          }}
        />
        <TextField source='id' label='Id' sortable={false} />
        <TextField source='accountId' label='Account Id' />
        <TextField source='accountNumber' label='Account number' />
        <TextField source='customTypeLabel' label='Type' />
        <TextField source='primaryAccountHolder.firstName' label='First Name' />
        <TextField source='primaryAccountHolder.middleName' label='Middle Name' sortable={false} />
        <TextField source='primaryAccountHolder.lastName' label='Last Name' />
        <TextField source='primaryAccountHolder.suffix' label='Suffix' sortable={false} />
        <TextField source='primaryAccountHolder.email' label='Email' />
        <FunctionField
          render={(record: BaseAccount) => {
            return <PhoneNumberArrayField record={record.primaryAccountHolder?.phones} />;
          }}
          label='Phone Number'
        />
        <FunctionField
          label='Status'
          render={(account: BaseAccount) => {
            if (account.status) {
              return <AccountStatusChip value={account.status} />;
            }

            return null;
          }}
        />
      </Datagrid>
    </List>
  );
};
